export default __webpack_public_path__ + "07c1eb3918fdd1ce90e1462397dc14f8.svg";